// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"85983d9a","204":"17660aba","845":"eec7faeb","891":"156f4bc1","941":"6bfd8ea8"}[chunkId] + ".chunk.css";
};